export default __webpack_public_path__ + "static/media/Version (2) - LOTR_02.5b708c00.jpg";